var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"join"}},[_c('Nav',{attrs:{"type":"transparent"}}),_c('span',{staticClass:"pageTitle"},[_vm._v("加盟会员")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pContent"},[_c('div',{staticClass:"building"},[_vm._v(" 建设中，敬请期待～ ")])])
}]

export { render, staticRenderFns }